export const DEV_ENV = 'development'
export const TEST_ENV = 'staging'
export const PROD_ENV = 'production'
export const LOCAL_ENV = 'local'


// WEBPACK FOOTER //
// ./src/constants/environments.js